import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const createGroup = createAsyncThunk("createGroup", async (data, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post("/groups", data);
		return response.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data?.message || "Failed to create group");
	}
});

const GroupCreateSlice = createSlice({
	name: "GroupCreateSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetGroupCreate: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(createGroup.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});

		builder.addCase(createGroup.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(createGroup.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetGroupCreate } = GroupCreateSlice.actions;

export default GroupCreateSlice.reducer;
